import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    BYOButton,
    ContentCard,
    Headline3,
} from '@cdm/quickenloans-library/lib';
import { ArrowForward } from '@mui/icons-material';
import * as styles from '../../ArticleMultipleChoiceCTA.module.scss';
import LearningCenterSourceIdLink from '../../../LearningCenterSourceIdLink';
import { testAttributes, multiCtaEnvs } from '../../Constants';
import Tile from '../../Tile';
import HomePurchaseImage from '../../illustrations/home_purchase.svg';
import HomeRefinanceImage from '../../illustrations/home_refinance.svg';
import TapIntoEquityImage from '../../illustrations/tap_into_equity.svg';

const ArticleMultipleChoiceCTA = ({
    buttonLabel,
    buttonIcon = <ArrowForward />,
    buttonAttributes = { target: '_blank' },
    className = '',
    title = null,
    articleId = '',
}) =>
{
    const [selectedTile, setSelectedTile] = useState('');
    const [url, setUrl] = useState('');
    const shouldDisableButton = selectedTile === '';

    const handleSelectedTile = (event, item) =>
    {
        setSelectedTile(item.id);
        setUrl(item.url);
    };

    const activeEnv =
        process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    return (
        <ContentCard
            className={`${className} ${styles.articleMultipleChoiceCTA}`}
            testId={testAttributes.MULTIPLE_CTA_CONTAINER}
        >
            <div className={`noMargin ${styles.wrapper}`}>
                {title && (
                    <Headline3
                        className="noMargin"
                        testId={testAttributes.MULTIPLE_CTA_HEAD_CONTAINER}
                    >
                        {title}
                    </Headline3>
                )}
                <div
                    className={`noMargin ${styles.body} ${styles.bodyContainer}`}
                    data-testid={testAttributes.MULTIPLE_CTA_BODY_CONTAINER}
                >
                    {[
                        {
                            id: 'HomePurchaseImage',
                            img: HomePurchaseImage,
                            title: 'Home Purchase',
                            url: multiCtaEnvs[activeEnv].homePurchase,
                        },
                        {
                            id: 'HomeRefinanceImage',
                            img: HomeRefinanceImage,
                            title: 'Home Refinance',
                            url: multiCtaEnvs[activeEnv].homeRefinance,
                        },
                        {
                            id: 'TapIntoEquityImage',
                            img: TapIntoEquityImage,
                            title: 'Tap Into Equity',
                            url: multiCtaEnvs[activeEnv].homeEquity,
                        },
                    ].map((item) => (
                        <Tile
                            item={item}
                            handleSelectedTile={handleSelectedTile}
                            key={item.id}
                            selectedTile={selectedTile}
                        />
                    ))}
                </div>
                <div
                    className={`noMargin ${styles.actions}`}
                    data-testid={testAttributes.MULTIPLE_CTA_ACTIONS_CONTAINER}
                >
                    <BYOButton
                        as={LearningCenterSourceIdLink}
                        href={url}
                        articleId={articleId}
                        color="green"
                        testId={testAttributes.MULTIPLE_CTA_BUTTON}
                        disabled={shouldDisableButton}
                        iconRight={
                            buttonIcon === null ? null : <ArrowForward />
                        }
                        iconTestId={testAttributes.MULTIPLE_CTA_BUTTON_ICON}
                        // eslint-disable-next-line react/style-prop-object
                        style="filled"
                        {...buttonAttributes}
                    >
                        {buttonLabel}
                    </BYOButton>
                </div>
            </div>
        </ContentCard>
    );
};

ArticleMultipleChoiceCTA.propTypes = {
    /** Label of the button */
    buttonLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.array,
    ]).isRequired,
    /** Icon for the button */
    buttonIcon: PropTypes.object,
    /** Additional attributes for the button, e.g. target="_blank", rel="nofollow" */
    buttonAttributes: PropTypes.object,
    /** CSS classes */
    className: PropTypes.string,
    /** Title of the article multiple choice CTA */
    title: PropTypes.string,
    /** Article Identifier */
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ArticleMultipleChoiceCTA;
